import React from "react";
import { useSelector } from "react-redux";
import { ProgressIndicator } from "rhombus-react";

import InfoBanner from "widgets/InfoBanner";
import StatusColumn from "widgets/grid/cells/StatusColumn";

import useActiveCreative from "hooks/useActiveCreative";

import "./DeleteConcept.css" ;

export default function DeleteConcept(props){
	/* istanbul ignore next */
	const { creativeId } = props;
	let {
		items,
		isLoaded,
		canDelete,
	} = useSelector(state => state.creatives.modalProps?.conceptCreatives);

	useActiveCreative(creativeId);

	let dependentInfoMsg = "Are you sure you want to delete the selected concept and all of its creatives?";

	if(!canDelete) {
		dependentInfoMsg = (<><strong>Please Note</strong>: Can only delete a concept if all creatives are in production status</>);
	}

	const $headingRow = ["Creative Name", "ID", "Status"].map((ea)=>{
		return <th scope="col" key={ea}>{ea}</th>;
	});

	const renderRow = items?.map((val)=>{
		return (
			<tr key={`${val.id}`}>
				<td className="name-col" title={val.name}>{val.name}</td>
				<td className="id-col">{val.id}</td>
				<td className="status-col"><StatusColumn value={val.approvalValue} /></td>
			</tr>
		);
	});

	return (
		<div className="delete-concept-container">
			<ProgressIndicator isLoading={!isLoaded} />
			{canDelete && (<p className="concept-banner">{dependentInfoMsg}</p>)}
			{!canDelete && (
				<InfoBanner className="concept-banner">
					{dependentInfoMsg}
				</InfoBanner>
			)}
			<table className="delete-concept-table basic-table">
				<thead className="header">
					<tr className="headrow">{$headingRow}</tr>
				</thead>
				<tbody>{renderRow}</tbody>
			</table>
		</div>
	);
}

DeleteConcept.displayName = "DeleteConceptModal";
